import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { useDispatch } from "react-redux";
import {
  createAdvertismentService,
  getAdvertisementsService,
  updateAdvertisementService,
} from "redux/services/general_service";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const BannerModal = ({ isOpen, onClose, banner }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    image: null,
    imagePreview: null,
    url: "",
    type: "website",
    is_active: 1,
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (banner) {
      setFormData({
        image: null,
        imagePreview: banner?.image || null,
        url: banner?.url || "",
        type: banner?.type || "website",
        is_active: banner?.is_active ? 1 : 0,
      });
    } else {
      setFormData({
        image: null,
        imagePreview: null,
        url: "",
        type: "website",
        is_active: banner?.is_active ? 1 : 0,
      });
    }

    setErrors({});
  }, [banner, isOpen]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData((prev) => ({
        ...prev,
        image: file,
        imagePreview: reader.result,
      }));
    };
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    if (!formData.image && !banner) {
      setErrors({ image: "الصورة مطلوبة" });
      return;
    }

    try {
      setLoading(true);

      const dataToSend = new FormData();

      if (formData.image) {
        dataToSend.append("image", formData.image);
      }

      dataToSend.append("url", formData.url);
      dataToSend.append("type", formData.type);
      dataToSend.append("is_active", formData.is_active);

      if (banner) {
        //  dataToSend.append("_method", "PUT");

        const response = await dispatch(
          updateAdvertisementService({
            id: banner.id,
            formData: dataToSend,
          }),
        );

        if (response?.payload?.status === 200) {
          toast.success("تم التعديل بنجاح");
        }
      } else {
        dataToSend.append("order", 1);

        const response = await dispatch(
          createAdvertismentService({ data: dataToSend }),
        );

        if (response?.payload?.status === 200) {
          toast.success("تمت الإضافة بنجاح");
        }
      }

      dispatch(getAdvertisementsService({ page: 1, type: "banner" }));
      onClose();
    } catch (error) {
      toast.error("حدث خطأ");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-xl w-full max-w-2xl flex flex-col">
        <div className="flex justify-between p-6 border-b">
          <h2 className="text-lg font-semibold">
            {banner ? "تعديل بنر" : "إضافة بنر"}
          </h2>
          <button onClick={onClose}>
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-6">
          {/* Type */}
          <div>
            <label className="block mb-2">نوع الإعلان</label>
            <div className="flex gap-4">
              {["website", "mobile", "both"].map((opt) => (
                <label key={opt} className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={formData.type === opt}
                    onChange={() => handleInputChange("type", opt)}
                  />
                  {opt}
                </label>
              ))}
            </div>
          </div>

          {/* Status */}
          <div>
            <label className="block mb-2">الحالة</label>
            <input
              type="checkbox"
              checked={formData.is_active === 1}
              onChange={(e) =>
                handleInputChange("is_active", e.target.checked ? 1 : 0)
              }
            />
            <label htmlFor="is_special" className="text-sm font-medium">
              {t("نشط")}
            </label>
          </div>

          {/* URL */}
          <div>
            <label className="block mb-2">الرابط</label>
            <input
              type="url"
              className="w-full border p-2 rounded"
              value={formData.url}
              onChange={(e) => handleInputChange("url", e.target.value)}
            />
          </div>

          {/* Image */}
          <div>
            {!formData.imagePreview ? (
              <input type="file" onChange={handleFileUpload} />
            ) : (
              <img
                src={formData.imagePreview}
                className="h-40 object-contain"
                alt="preview"
              />
            )}
          </div>

          {errors.image && (
            <p className="text-red-500 text-sm">{errors.image}</p>
          )}
        </div>

     <div className="flex justify-end p-6 border-t gap-3">

  <Button
    onClick={handleSave}
    disabled={loading}
    className="h-10 px-6"
  >
    {loading ? "جاري الحفظ..." : banner ? "تحديث" : "إضافة"}
  </Button>

  <button
    className="h-10 px-6 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium disabled:opacity-50"
    onClick={onClose}
    disabled={loading}
  >
    إلغاء
  </button>

</div>
      </div>
    </div>
  );
};

export default BannerModal;
